import { combineReducers } from 'redux';

import list from './list';
import manage from './manage';

export default combineReducers({
  list,
  manage
});
